module.exports = {
  DEBUG_MODE: true,
};